import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Search, Tag } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface FilterControlsProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  onResetFilters: () => void;
  showOtherSubjectsOnly: boolean;
  setShowOtherSubjectsOnly: (value: boolean) => void;
}

export const FilterControls: React.FC<FilterControlsProps> = ({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  onResetFilters,
  showOtherSubjectsOnly,
  setShowOtherSubjectsOnly
}) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 items-end">
      {/* Search input */}
      <div className="relative flex-grow">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="ค้นหาจากชื่อนักเรียน, รหัสครู, วันที่"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10 pr-4"
        />
      </div>
      
      {/* Status filter */}
      <div className="flex flex-col space-y-2 w-full md:w-auto">
        <label htmlFor="status-filter" className="text-sm font-medium">
          สถานะ
        </label>
        <Select value={statusFilter} onValueChange={setStatusFilter}>
          <SelectTrigger className="w-full md:w-[180px]">
            <SelectValue placeholder="ทุกสถานะ" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">ทุกสถานะ</SelectItem>
            <SelectItem value="WAITING">รอดำเนินการ</SelectItem>
            <SelectItem value="APPROVED">อนุมัติแล้ว</SelectItem>
            <SelectItem value="REJECTED">ไม่อนุมัติ</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      {/* Other subject checkbox - enhanced with Tag icon */}
      <div className="flex items-center space-x-2 px-3 py-2 border rounded-md bg-white">
        <Checkbox 
          id="other-subjects" 
          checked={showOtherSubjectsOnly}
          onCheckedChange={(checked) => setShowOtherSubjectsOnly(checked as boolean)} 
        />
        <Label 
          htmlFor="other-subjects" 
          className="text-sm cursor-pointer flex items-center gap-1"
        >
          <Tag className="h-3 w-3 text-amber-600" />
          <span>แสดงเฉพาะหัวข้ออื่นๆ</span>
        </Label>
      </div>
      
      {/* Clear filters button */}
      <Button 
        variant="outline" 
        onClick={onResetFilters}
        className="h-10"
      >
        รีเซ็ตตัวกรอง
      </Button>
    </div>
  );
};
